import common from '../en/common.json';
import details from '../en/details.json';

export default {
  common,
  details,
};
